import PropTypes from 'prop-types';
import { tv } from 'tailwind-variants';

function Button({ type, size, onClick, message, disabled = false }) {
  return (
    <button
      className={buttonStyles({
        type: type,
        size: size || 'medium',
        disabled: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      {message}
    </button>
  );
}

const buttonStyles = tv({
  base: 'px-4 py-2 rounded-md font-medium hover:cursor-pointer',
  variants: {
    type: {
      primary: 'bg-carrier-blue text-white hover:opacity-90',
      cancel: 'bg-gray-300 text-black hover:bg-gray-400',
      delete: 'bg-red-600 text-white hover:bg-red-700',
    },
    size: {
      small: 'text-sm px-2 py-1',
      medium: 'text-base px-4 py-2',
      large: 'text-lg px-6 py-3',
    },
    disabled: {
      true: 'opacity-50 cursor-not-allowed hover:cursor-not-allowed',
      false: '',
    },
  },
});

Button.propTypes = {
  type: PropTypes.oneOf(['primary', 'cancel', 'delete']).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  onClick: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default Button;
